export const NewEmployee = () => {
  return <>TBA: New Employee form page</>;
};
